import React from 'react';

function Utah({handleClick, className}) {
  return (
    <path onClick={handleClick} className={className} id="UT" d="M228.4 305.9l24.6 3.6 1.9-13.7 7-50.5 2.3-22-32.2-3.5 2.2-13.1 1.8-10.6-34.7-6.1-12.5-2.5-10.6 52.9-5.4 30-3.3 15.4-1.7 9.2z"><title>Utah</title></path>
  );
}

export default Utah;
